import { RewardFareClass, FlightsClassTypes, type FareClassWithReward } from 'constants/flight'

/**
 * Maps a base cabin to its reward-seat companion variant.
 *
 * Currently only Maldives charter has reward fares (Economy/Premium/Business → *_REWARDS),
 * but the shape is product-agnostic — extend this map (and {@link RewardFareClass})
 * if other flight products gain reward fares for additional cabins (e.g. SkyLounge).
 */
export const REWARD_FOR_BASE_CABIN: Partial<Record<FlightsClassTypes, RewardFareClass>> = {
  [FlightsClassTypes.ECONOMY]: RewardFareClass.ECONOMY_REWARDS,
  [FlightsClassTypes.PREMIUM]: RewardFareClass.PREMIUM_REWARDS,
  [FlightsClassTypes.BUSINESS]: RewardFareClass.BUSINESS_REWARDS,
}

/** Inverse of {@link REWARD_FOR_BASE_CABIN}, derived once at module load. Internal to {@link toBaseFareClass}. */
const BASE_CABIN_FOR_REWARD: Record<RewardFareClass, FlightsClassTypes> = Object.fromEntries(
  Object.entries(REWARD_FOR_BASE_CABIN).map(([cash, reward]) => [reward, cash]),
) as Record<RewardFareClass, FlightsClassTypes>

/** Strips the reward suffix from a fare class; non-reward fare classes pass through unchanged. */
export function toBaseFareClass(fareClass: FareClassWithReward): FlightsClassTypes {
  return BASE_CABIN_FOR_REWARD[fareClass as RewardFareClass] ?? fareClass as FlightsClassTypes
}
